'use client';

import React from 'react';
import { SlidersHorizontal } from 'lucide-react';
import { Button } from '@/shared/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuLabel,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/shared/components/ui/dropdown-menu';

export interface SortOption {
  value: string;
  label: string;
}

export interface SortDropdownProps {
  sortBy: string;
  sortOrder: 'asc' | 'desc';
  options: SortOption[];
  onSortByChange: (value: string) => void;
  onSortOrderChange: (order: 'asc' | 'desc') => void;
  labels: {
    sortBy: string;
    sortOrder: string;
    asc: string;
    desc: string;
  };
  testId?: string;
}

export function SortDropdown({
  sortBy,
  sortOrder,
  options,
  onSortByChange,
  onSortOrderChange,
  labels,
  testId = 'sort-dropdown',
}: SortDropdownProps) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          data-testid={testId}
          variant="outline"
          size="icon"
        >
          <SlidersHorizontal className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-[200px]">
        <DropdownMenuLabel>{labels.sortBy}</DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuRadioGroup
          value={sortBy}
          onValueChange={onSortByChange}
        >
          {options.map((option) => (
            <DropdownMenuRadioItem key={option.value} value={option.value}>
              {option.label}
            </DropdownMenuRadioItem>
          ))}
        </DropdownMenuRadioGroup>
        <DropdownMenuSeparator />
        <DropdownMenuLabel>{labels.sortOrder}</DropdownMenuLabel>
        <DropdownMenuRadioGroup
          value={sortOrder}
          onValueChange={(v) => onSortOrderChange(v as 'asc' | 'desc')}
        >
          <DropdownMenuRadioItem value="desc">
            {labels.desc}
          </DropdownMenuRadioItem>
          <DropdownMenuRadioItem value="asc">
            {labels.asc}
          </DropdownMenuRadioItem>
        </DropdownMenuRadioGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
